<template>
    <b-card
        header="Providers"
        header-text-variant="white"
        header-bg-variant="info"
        >
        <b-row class="mb-2">
            <b-col>
                <b-btn variant="info" @click="addCaregiver()">Add Provider to Claimant</b-btn>
            </b-col>
        </b-row>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>Assigned Provider</th>
                    <th>Provider Rate</th>
                    <th>Status</th>
                    <th>Confirmed</th>
                    <th>Corrected</th>
                    <th v-if=" !isCarrierManager "></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td><a :href="`${providerUrlPrefix}/${item.id}`">{{ item.firstname }} {{ item.lastname }}</a></td>
                    <td>{{ moneyFormat(item.pivot.caregiver_hourly_rate) }}</td>
                    <td>{{ formatEnrollmentStatus(item.enrollment_status) }}</td>
                    <td>{{ item.pivot.confirmed_at ? formatDateFromUTC(item.pivot.confirmed_at) : 'No' }}</td>
                    <td>{{ formatDateFromUTC(item.pivot.updated_at) }}</td>
                    <td v-if=" !isCarrierManager ">
                        <b-btn size="sm" variant="danger" @click="disassociateCaregiver(item)">Disassociate</b-btn>
                        <b-btn size="sm" @click="editCaregiver(item)">Edit</b-btn>
                        <b-btn size="sm" variant="primary" @click="showRateHistory(item)">Rate History</b-btn>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- EDIT MODAL -->
        <b-modal id="clientCaregiverModal" :title="modalTitle" v-model="clientCaregiverModal" ref="clientCaregiverModal">
            <b-container fluid>
                <b-row v-if="!selectedCaregiver.id">
                    <b-col lg="12">
                        <div style="position: relative">
                            <div class="d-flex">
                                <b-form-input autocomplete="off" aria-label="Search users in CareExchange" placeholder="Search provider" min="2"
                                              v-model="searchTerm" @input="onSearch" @focus="showResults" @blur="hideResults"
                                              >
                                </b-form-input>
                            </div>
                            <div v-show="isSearching" class="search-results" >
                                <b-dropdown-item v-if="isLoading && searchTerm.length >= 3" class="text-center"><i class="fa fa-spinner fa-spin fa-2x fa-fw" style="color:#26c6da"></i></b-dropdown-item>
                                <b-dropdown-item v-else-if="isLoading && searchTerm.length < 3" class="text-center">3 characters minimum to search providers</b-dropdown-item>
                                <b-dropdown-item v-else-if="caregiverList.length === 0  && !isLoading">No Result.</b-dropdown-item>
                                <b-dropdown-item v-else v-for="( item, key ) in caregiverList" :key=" 'drop' + key + item.id "
                                                 >
                                    <div @click="onClick(item)" class="d-flex align-items-center justify-content-between">
                                        <p class="mb-0">{{ item.name }}</p>
                                    </div>
                                </b-dropdown-item>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="form.caregiver_id">
                    <b-col lg="12">
                        <b-form-group label="Provider Hourly Rate" label-for="caregiver_hourly_rate">
                            <b-form-input
                                id="caregiver_hourly_rate"
                                name="caregiver_hourly_rate"
                                type="number"
                                v-model="form.caregiver_hourly_rate"
                                >
                            </b-form-input>
                            <input-help :form="form" field="caregiver_hourly_rate" text="Enter the hourly earnings for this provider."></input-help>
                        </b-form-group>
                        <!-- <b-form-group label="Confirmed Rate?" label-for="confirmed">
                            <b-form-select id="confirmed"
                                           v-model="form.confirmed"
                            >
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </b-form-select>
                            <input-help :form="form" field="confirmed" text="Select whether or not the rate has been confirmed with the provider." />
                        </b-form-group> -->
                    </b-col>
               </b-row>
            </b-container>
            <div slot="modal-footer">
               <b-btn variant="default" @click="clientCaregiverModal=false">Close</b-btn>
               <b-btn variant="info" @click="saveCaregiver()" v-if="form.caregiver_id">Save</b-btn>
            </div>
        </b-modal>
        <!-- /end EDIT MODAL -->

        <!-- DISASSOCIATE MODAL -->
        <b-modal title="Are you sure?" v-model="confirmModal" ref="confirmModal">
            Are you sure you want to disassociate {{ selectedCaregiver.name }}?
            <div slot="modal-footer">
               <b-btn variant="default" @click="confirmModal = false">Cancel</b-btn>
               <b-btn variant="danger" @click="disassociateCaregiver(selectedCaregiver, false)">Disassociate</b-btn>
            </div>
        </b-modal>
        <!-- /end DISASSOCIATE MODAL -->

        <b-modal v-if="rateHistoryModal" :title="`Rate History for ${selectedCaregiver.name}`" v-model="rateHistoryModal" ref="rateHistoryModal">
            <div class="table-responsive">
                <table class="table  table-striped">
                    <thead>
                    <tr>
                        <th>Rate</th>
                        <th>Date Changed</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in rateHistory" :key="item.id">
                            <td>{{ moneyFormat(item.rate) }}</td>
                            <td>{{ formatDateFromUTC(item.updated_at) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div slot="modal-footer">
               <b-btn variant="default" @click="rateHistoryModal = false">Close</b-btn>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
    import FormatsNumbers from '../../../mixins/FormatsNumbers'
    import FormatsStrings from "../../../mixins/FormatsStrings";
    import FormatsDates from "../../../mixins/FormatsDates";
    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import UsesRole from "../../../mixins/UsesRole";

    export default {
        props: {
            'client_id': {},
            'allyFee': Number,
            'paymentTypeMessage': {
                default() {
                    return '';
                }
            }
        },

        mixins: [FormatsNumbers, FormatsStrings, FormatsDates, EnrollmentStatuses, UsesRole],

        data() {
            return {
                caregiverList: [],
                items: [],
                clientCaregiverModal: false,
                clientExcludeCaregiverModal: false,
                selectedCaregiver: {},
                form: new Form(),
                excludeForm: {},
                excludedCaregivers: [],
                confirmModal: false,
                rateHistoryModal: false,
                rateHistory: [],
                isLoading: false,
                isSearching: false,
                searchTerm: ''
            }
        },

        mounted() {
            this.fetchAssignedCaregivers();
        },

        created() {
            this.fetchExcludedCaregivers();
        },

        methods: {
            showRateHistory(caregiver) {
                axios.get(`${this.claimantUrlPrefix}/${this.client_id}/${this.providerModel}/${caregiver.id}/rate-history`)
                    .then( ({ data }) => {
                        this.rateHistory = data;
                        this.selectedCaregiver = caregiver;
                        this.rateHistoryModal = true;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },

            addCaregiver() {
                this.selectedCaregiver = {};
                this.form = new Form({
                    caregiver_id: null,
                    caregiver_hourly_rate: null,
                    caregiver_daily_rate: null,
                    provider_hourly_fee: 0,
                    provider_daily_fee: null,
                    // confirmed: 1,
                });
                this.clientCaregiverModal = true;
            },

            editCaregiver(item) {
                this.selectedCaregiver = item;
                this.form = new Form({
                    caregiver_id: item.id,
                    caregiver_hourly_rate: item.pivot.caregiver_hourly_rate,
                    caregiver_daily_rate: item.pivot.caregiver_daily_rate,
                    provider_hourly_fee: item.pivot.provider_hourly_fee,
                    provider_daily_fee: item.pivot.provider_daily_fee,
                    // confirmed: item.pivot.confirmed_at ? 1 : 0,
                });
                this.clientCaregiverModal = true;
            },

            saveCaregiver() {
                let component = this;
                this.form.post(`${this.claimantUrlPrefix}/${this.client_id}/${this.providerModel}`)
                    .then((response) => {
                        this.fetchCaregivers()
                        component.items = component.items.filter(caregiver => {
                            return caregiver.id !== response.data.data.id;
                        });
                        component.items.unshift(response.data.data);
                        component.clientCaregiverModal = false;
                    })
            },

            fetchAssignedCaregivers() {
                axios.get(`${this.claimantUrlPrefix}/${this.client_id}/${this.providerModel}`)
                    .then(response => {
                        if (Array.isArray(response.data)) {
                            this.items = _.sortBy(response.data, ['lastname', 'firstname']);
                        } else {
                            this.items = [];
                        }
                    });
            },

            fetchCaregivers() {
                axios.get(`${this.claimantUrlPrefix}/${this.client_id}/potential-${this.providerModel}`)
                    .then(response => {
                        this.caregiverList = response.data;
                    });
            },

            fetchExcludedCaregivers() {
                axios.get(`${this.claimantUrlPrefix}/${this.client_id}/excluded-${this.providerModel}`)
                    .then(response => {
                        this.excludedCaregivers = response.data;
                    }).catch(error => {
                        console.error(error.response);
                    });
            },

            excludeCaregiver() {
                console.log('Excluding ' + this.excludeForm.caregiver_id);
                axios.post(`${this.claimantUrlPrefix}/${this.client_id}/exclude-${this.providerSingular}`, this.excludeForm)
                    .then(response => {
                        this.fetchExcludedCaregivers();
                    }).catch(error => {
                        console.error(error.response);
                    });
            },

            removeExcludedCaregiver(id) {
                axios.delete(`${this.claimantUrlPrefix}/excluded-${this.providerSingular}/${id}`)
                    .then(response => {
                        this.fetchExcludedCaregivers();
                    }).catch(error => {
                        console.error(error.response);
                    });
            },

            disassociateCaregiver(caregiver, confirm = true) {
                if (confirm) {
                    this.selectedCaregiver = caregiver;
                    this.confirmModal = true;
                    return;
                }

                let form = new Form({caregiver_id: caregiver.id});
                form.post(`${this.claimantUrlPrefix}/${this.client_id}/detach-${this.providerSingular}`)
                    .then(() => {
                        this.fetchAssignedCaregivers();
                        this.selectedCaregiver = {};
                        this.confirmModal = false;
                    });
            },

            onClick(item) {
                this.form.caregiver_id = item.id;
                this.searchTerm = item.name;
            },

            onSearch() {
                this.showResults();

                if (this.searchTerm === '') {
                    this.caregiverList = [];
                    return;
                }
                this.isLoading = true;

                this.searchCaregivers(this);
            },

            searchCaregivers: _.debounce((vm) => {
                if (vm.searchTerm && vm.searchTerm.length >= 3) {
                    axios.get(`${vm.claimantUrlPrefix}/${vm.client_id}/potential-${vm.providerModel}?search=${vm.searchTerm}`)
                        .then(response => {
                            vm.showResults();
                            vm.caregiverList = response.data || [];
                            vm.isLoading = false;
                        })
                        .catch(e => {
                            vm.showResults(false);
                            vm.caregiverList = [];
                            vm.isLoading = false;
                        });
                }
            }, 350),

            showResults(show = true) {
                if (this.searchTerm === '') {
                    show = false;
                }

                this.isSearching = show;
            },

            hideResults() {
                setTimeout(() => {
                    this.isSearching = false;
                }, 200);
            },
        },

        computed: {
            modalTitle() {
                if (this.selectedCaregiver.id) {
                    return 'Edit Provider Assignment';
                }
                return 'Add Provider Assignment';
            },

            subTotal() {
                return parseFloat(this.form.provider_hourly_fee) + parseFloat(this.form.caregiver_hourly_rate);
            },

            allyTotal() {
                return this.subTotal * this.allyFee;
            },

            total() {
                return this.subTotal + this.allyTotal;
            }
        }
    }
</script>

<style>
    th.hourly, td.hourly {
        background-color: #eee;
    }
    th.daily, td.daily {
        background-color: #f5f5f5;
    }
    thead th {
        padding: .4rem .75rem !important;
    }
    tr td.hourly, tr th.hourly {
        text-align: center;
    }
</style>